import { render, staticRenderFns } from "./CardModule.vue?vue&type=template&id=a10d097a&scoped=true"
import script from "./CardModule.vue?vue&type=script&lang=js"
export * from "./CardModule.vue?vue&type=script&lang=js"
import style0 from "./CardModule.vue?vue&type=style&index=0&id=a10d097a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d097a",
  null
  
)

export default component.exports